// Onboarding route — `/_authed/onboarding`.
//
// Renders the 6-step wizard (US-016..US-029, US-038). `OnboardingRedirect`
// in `features/shell/AppShell` auto-routes fresh users here when
// `onboardingCompletedAt` is null; Settings → "Restart onboarding" links
// here directly.

import { createRoute } from '@tanstack/react-router';

import { OnboardingShell } from '@/features/onboarding/OnboardingShell';

import { Route as AuthedLayoutRoute } from './__layout';

export const Route = createRoute({
  getParentRoute: () => AuthedLayoutRoute,
  path: '/onboarding',
  component: OnboardingPage,
});

function OnboardingPage() {
  return <OnboardingShell />;
}
